import { render, staticRenderFns } from "./boldplay.vue?vue&type=template&id=2d4d4bff&scoped=true"
import script from "./boldplay.vue?vue&type=script&lang=js"
export * from "./boldplay.vue?vue&type=script&lang=js"
import style0 from "./boldplay.vue?vue&type=style&index=0&id=2d4d4bff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d4bff",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/boldplay.vue
// module id = yV1u
// module chunks = 0